"use strict";

export const documentPatterns = {
    cpf: "000.000.000-00",
    cnpj: "00.000.000/0000-00",
    cnpjAlfanumerico: "AA.AAA.AAA/AAAA-00",
    cep: "00000-000"
};

export const phonePatterns = {
    landline: "(00) 0000-0000",
    mobile: "(00) 00000-0000"
};

export const datePatterns = {
    date: "00/00/0000"
};
